var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#020002"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.736 17.264-1.861-1.861v-2.466a6.884 6.884 0 0 0-6.188-6.84v-1.41h-1.374v1.41a6.884 6.884 0 0 0-6.188 6.84v2.466l-1.861 1.86a.687.687 0 0 0-.202.487v2.063a.687.687 0 0 0 .688.687h4.813v.688a3.438 3.438 0 0 0 6.874 0V20.5h4.813a.687.687 0 0 0 .688-.688V17.75a.688.688 0 0 0-.202-.486zm-6.674 3.924a2.062 2.062 0 0 1-4.125 0V20.5h4.126v.688z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.6287248b6ddf0bd89138ab21b42b1382.svg";
export { ForwardRef as ReactComponent };